<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.departments') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{ $ml.get('shared.definitions') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.departments') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-5">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{ $ml.get('departments.departmentInfo') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0" @click="newDepartment()"
                  class="btn btn-sm btn-warning">{{ $ml.get('departments.newDepartment') }}</button>
              </div>
            </div>
            <div class="box-body">
              <div class="form-group">
                <label>{{ $ml.get('departments.departmentName') }}</label>
                <input id="selectedNode" @click="selectNode()" type="text" class="form-control"
                  v-model="department.name" />
              </div>
              <div class="form-group">
                <label>{{ $ml.get('departments.mainDepartment') }}</label>
                <select @change="changeMainDepartment($event)" class="form-control">
                  <option :selected="department.mainDepartmentId == null" value="">{{ $ml.get('general.select') }}
                  </option>
                  <option v-for="mainDep in getDepartmentList" :key="mainDep.id" :value="mainDep.id"
                    :selected="mainDep.id == department.mainDepartmentId">{{ mainDep.name }}</option>
                </select>
              </div>
              <span class="form-control checkbox" style="margin-bottom:10px;">
                <label style="margin-left:20px;">
                  <input :checked="department.displayOnDashboard"
                    @change="department.displayOnDashboard = !department.displayOnDashboard" type="checkbox" />
                  {{ $ml.get('departments.displayOnDashboard') }}
                </label>
              </span>
              <div class="form-group">
                <label>1.Sorumlu Kullanıcı</label>
                <select @change="changeAuthUser1($event)" class="form-control">
                  <option :value="0">Seçilmedi</option>
                  <option v-for="user in userList" :selected="user.id == department.authorizedUser1" :key="user.id"
                    :value="user.id">{{ user.name }} - {{ user.title }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>2.Sorumlu Kullanıcı</label>
                <select @change="changeAuthUser2($event)" class="form-control">
                  <option :value="0">Seçilmedi</option>
                  <option v-for="user in userList" :selected="user.id == department.authorizedUser2" :key="user.id"
                    :value="user.id">{{ user.name }} - {{ user.title }}</option>
                </select>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button v-show="!isNewDepartment && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-sil" class="btn btn-sm btn-danger"
                  style="margin: 5px; width:120px;">{{ $ml.get('general.delete') }}</button>
                <button v-show="isNewDepartment && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-kaydet" class="btn btn-sm btn-success"
                  style="margin: 5px; width:120px;">{{ $ml.get('general.save') }}</button>
                <button v-show="!isNewDepartment && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-guncelle" class="btn btn-sm btn-success"
                  style="margin: 5px; width:120px;">{{ $ml.get('general.update') }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-7">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{ $ml.get('departments.departmentList') }}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div v-show="getDepartmentList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <div id="treeview"></div>
              </div>
              <div v-show="getDepartmentList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('departments.departmentNotRecord') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.department.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('departments.isContinueDepartmentUpdate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveDepartment()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ this.department.name }}</p>
              <span>{{ $ml.get('departments.isContinueDepartmentSave') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveDepartment()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.department.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('departments.isContinueDepartmentDelete') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteDepartment()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      department: {
        id: null,
        name: "",
        mainDepartmentId: null,
        isActive: true,
        locationTree: "",
        displayOnDashboard: false,
        authorizedUser1: 0,
        authorizedUser2: 0
      },
      users: [],
      departments: [],
      isNewDepartment: true
    };
  },
  computed: {
    activeUser() {
      return this.$store.getters.getUser;
    },
    userList() {
      return this.users.sort((a, b) => {
        return this.turkishToUpper(a.name).localeCompare(
          this.turkishToUpper(b.name)
        );
      });
    },
    authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    getDepartmentList() {
      return this.departments.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 0;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 240;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    changeAuthUser1(event) {
      this.department.authorizedUser1 = event.target.value;
    },
    changeAuthUser2(event) {
      this.department.authorizedUser2 = event.target.value;
    },
    changeMainDepartment(event) {
      this.department.mainDepartmentId = event.target.value;
    },
    newDepartment() {
      this.isLoading = true;
      this.isNewDepartment = true;
      this.department.id = null;
      this.department.name = "";
      this.department.mainDepartmentId = null;
      this.department.displayOnDashboard = false;
      this.department.isActive = true;
      this.department.locationTree = "";
      this.department.authorizedUser1 = 0;
      this.department.authorizedUser2 = 0;
      this.isLoading = false;
    },
    selectNode() {
      this.isLoading = true;
      let node = document.getElementById("selectedNode").value;
      let selectedDepartment = this.getDepartmentFromName(node);
      if (selectedDepartment != null) {
        this.department.id = selectedDepartment.id;
        this.department.name = selectedDepartment.name;
        this.department.mainDepartmentId = selectedDepartment.mainDepartmentId;
        this.department.isActive = selectedDepartment.isActive;
        this.department.displayOnDashboard = selectedDepartment.displayOnDashboard;
        this.department.locationTree = selectedDepartment.locationTree;
        this.department.authorizedUser1 = selectedDepartment.authorizedUser1;
        this.department.authorizedUser2 = selectedDepartment.authorizedUser2;
        this.isNewDepartment = false;
      }
      this.isLoading = false;
    },
    selectDepartment(id) {
      let selectedDepartment = this.getDepartmentFromId(id);
      if (selectedDepartment != null) {
        this.department.id = selectedDepartment.id;
        this.department.name = selectedDepartment.name;
        this.department.mainDepartmentId = selectedDepartment.mainDepartmentId;
        this.department.isActive = selectedDepartment.isActive;
        this.department.displayOnDashboard = selectedDepartment.displayOnDashboard;
        this.department.locationTree = selectedDepartment.locationTree;
        this.department.authorizedUser1 = selectedDepartment.authorizedUser1;
        this.department.authorizedUser2 = selectedDepartment.authorizedUser2;
        this.isNewDepartment = false;
      }
    },
    getDepartmentFromId(id) {
      let aList = this.departments;
      let dep = aList.filter(function (department) {
        return department.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0];
      } else {
        return null;
      }
    },
    getDepartmentFromName(name) {
      let aList = this.departments;
      let dep = aList.filter(function (department) {
        return department.name == name;
      });
      if (dep != "" && dep != null) {
        return dep[0];
      } else {
        return null;
      }
    },
    async deleteDepartment() {
      if (this.isNewDepartment) {
        alertify.warning(this.$ml.get("alerts.selectedDepartmentNotBlank"));
      } else {
        try {
          this.isLoadingDetail = true;
          let id = this.department.id;
          const response = await this.$axios
            .delete("/Department/" + id)
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          this.getDepartments();
          this.newDepartment();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingDetail = false;
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
          this.isLoadingDetail = false;
        }
      }
    },
    async setLocationTree(mainDepId) {
      if (mainDepId != null) {
        let aList = this.departments;
        let dep = aList.filter(function (department) {
          return department.id == mainDepId;
        });
        if (dep[0].locationTree != "" && dep[0].locationTree != null) {
          return dep[0].locationTree + mainDepId + "/";
        } else {
          return "/0/";
        }
      } else {
        return "/0/";
      }
    },
    async saveDepartment() {
      if (
        this.department.id == this.department.mainDepartmentId &&
        this.department.id != null
      ) {
        alertify.warning(
          this.$ml.get("alerts.departmentAndMainDepartmentOverlap")
        );
        return;
      }
      this.department.locationTree = await this.setLocationTree(
        this.department.mainDepartmentId
      );
      this.isLoadingDetail = true;
      if (this.isNewDepartment) {
        try {
          let department2 = this.department;
          const response = await this.$axios
            .post("/Department", {
              name: department2.name,
              mainDepartmentId: parseInt(department2.mainDepartmentId),
              isActive: department2.isActive,
              locationTree: department2.locationTree,
              displayOnDashboard: department2.displayOnDashboard,
              authorizedUser1: department2.authorizedUser1,
              authorizedUser2: department2.authorizedUser2
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getDepartments();
          this.getDepartmentFromId(id);
          this.isNewDepartment = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let department2 = this.department;
          const response = await this.$axios
            .post("/Department/" + department2.id, {
              name: department2.name,
              mainDepartmentId: parseInt(department2.mainDepartmentId),
              isActive: department2.isActive,
              locationTree: department2.locationTree,
              displayOnDashboard: department2.displayOnDashboard,
              authorizedUser1: department2.authorizedUser1,
              authorizedUser2: department2.authorizedUser2
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getDepartments();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async setTree() {
      let departments = this.departments;
      var root = new TreeNode(
        this.activeUser.companyName +
        " ( " +
        this.$ml.get("shared.company") +
        " )"
      );
      await departments.forEach(doc => {
        if (doc.mainDepartmentId == null) {
          var node = new TreeNode(doc.name);
          root.addChild(node);
          this.addChildDep(node, doc.id);
        }
      });
      var tree = new TreeView(root, "#treeview", {
        leaf_icon: "<i class='fa fa-star'></i>",
        parent_icon: "<i class='fa fa-sitemap'></i>",
        open_icon: "<i class='fa fa-chevron-down'></i>",
        close_icon: "<i class='fa fa-chevron-right'></i>"
      });
    },
    async addChildDep(Tnode, mainDep) {
      let departments = this.departments;
      await departments.forEach(doc => {
        if (doc.mainDepartmentId == mainDep) {
          var node = new TreeNode(doc.name);
          Tnode.addChild(node);
          this.addChildDep(node, doc.id);
        }
      });
    },
    async getDepartments() {
      this.isLoading = true;
      const departmentList = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departmentList.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                displayOnDashboard: doc.displayOnDashboard,
                userId: doc.userId,
                authorizedUser1: doc.authorizedUser1,
                authorizedUser2: doc.authorizedUser2
              });
            });
            departmentList.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.departments = departmentList;
        this.setTree();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoading = false;
      }
    },
    getChildDep(dep) {
      let DepartmentList = this.departments;
      return DepartmentList.filter(function (department) {
        return department.id == dep.mainDepartmentId;
      });
    },
    getMainFind(id) {
      let DepartmentList = this.departments;
      let department = DepartmentList.filter(function (department) {
        return department.id == id;
      });
    },
    async getUsers() {
      try {
        this.isLoading = true;
        const users = [];
        const response = await this.$axios
          .get("/User")
          .then(response => {
            response.data.forEach(doc => {
              users.push({
                id: doc.id,
                name: doc.name,
                title: doc.title
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.users = users;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getUsers();
    await this.getDepartments();
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/departments/Departments.vue